module.exports = __webpack_public_path__ + "static/media/pic1.a8229b86.jpg";